<div>
    <router-outlet />
</div>

<app-update-notifier />

<cl-messages />
